import { useEffect } from "react";

import { useToggle } from "../../../hooks/useToggle";

export const useDevMode = (parsingError: boolean): [boolean, VoidFunction] => {
  const [devMode, toggleDevMode] = useToggle();

  useEffect(() => {
    if (parsingError && !devMode) {
      toggleDevMode();
    }
  }, [parsingError]); // eslint-disable-line

  return [devMode, toggleDevMode];
};
